import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ASAP_FRACIONADOS } from "app/auth/baseAsapFracionados";

export const getListaPedidos = createAsyncThunk(
  "listaPedidosFracionadosApp/listaPedidosFracionados/getListaPedidos",
  async (params: object) => {
    let response;
    try {
      response = await API_ASAP_FRACIONADOS.get(
        "/dashboard/fracionados/pedidos",
        {
          params: params,
        }
      );
    } catch (err: any) {
      console.error(err.response);
    }
    return response.data;
  }
);
